export default __webpack_public_path__ + "static/media/nexgtv-mobile-app-ui-design.7ab108bd.png";